const url = new URL(location.href);

const test = url.searchParams.get('test');
let host, chainId, protocol, port
if (test == 'local') {
  host = '127.0.0.1'
  port = 8888
  chainId = 'cf057bbfb72640471fd910bcb67639c22df9f92470936cddc1ade0e2f2e7dc4f'
  protocol = 'http'
} else if (test == 'kylin') {
  host = '//api-kylin.eosasia.one'
  port = 443
  chainId = '5fff1dae8dc8e2fc4d5b23b2c7665c97f9e9d8edf2b6485a86ba311c25639191'
  protocol = 'https'
} else if (test == 'jungle'){
  host = 'jungle.cryptolions.io'
  port = 18888
  chainId = '038f4b0fc8ff18a4f0842a8f0564611f6e96e8535901dd45e43ac8691a1c4dca'
  protocol = 'http'
}

export default {
  blockchain: 'eos',
  host,
  port, 
  protocol,
  chainId
};


